import React, {useEffect, useMemo} from 'react';
import {Outlet, useLocation, useNavigate, useParams} from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {useGetEmployeeByIdQuery} from '../../../api/services/employeeService';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import useUser from '../../../utility/hooks/useUser';
import {hasAnyVisibleStaffSection} from './staffProfileSectionAccess';

const allTabs = [
    {label: 'Basic', path: ''},
    {label: 'Forms', path: 'forms'},
    {label: 'Documents', path: 'documentation'},
];

export const EmployeeProfileDetails = () => {
    const {id} = useParams();
    const {data = {}, isLoading} = useGetEmployeeByIdQuery(id);
    const {user} = useUser();
    const navigate = useNavigate();
    const {pathname} = useLocation();
    const activePath = pathname.includes('/documentation')
        ? 'documentation'
        : pathname.includes('/forms')
            ? 'forms'
            : '';
    const showBasicTab = (user.permissions || []).length === 0 ||
        hasAnyVisibleStaffSection(user.permissions || []);
    const tabs = useMemo(
        () => allTabs.filter(tab => tab.path !== '' || showBasicTab),
        [showBasicTab]
    );

    useEffect(() => {
        if ((user.permissions || []).length > 0 && !showBasicTab && activePath === '') {
            navigate('forms', {replace: true});
        }
    }, [user.permissions, showBasicTab, activePath, navigate]);

    const navigateBack = () => navigate('/profiles');

    return (
        <Stack
            gap={2}
            marginTop={1}
            flexGrow={1}
        >
            <Stack>
                <Box marginBottom={1}>
                    <Button
                        variant="text"
                        startIcon={<ArrowBackRoundedIcon/>}
                        onClick={navigateBack}
                    >
                        Back
                    </Button>
                </Box>
                {
                    Object.keys(data).length
                        ? <Typography variant="h4">
                            Personal Details for {`${data.legalForename} ${data.legalSurname}`}
                        </Typography>
                        : null
                }
                <Tabs
                    value={tabs.some(tab => tab.path === activePath) ? activePath : (tabs[0]?.path ?? 'forms')}
                    onChange={(_, newPath) => navigate(newPath)}
                >
                    {tabs.map(tab => (
                        <Tab
                            key={tab.path}
                            label={tab.label}
                            value={tab.path}/>
                    ))}
                </Tabs>
            </Stack>
            <Outlet context={{data, isLoading}}/>
        </Stack>
    );
};

export default EmployeeProfileDetails;
